import React from 'react';
import './Partnership.css';
import { useLanguage } from '../LanguageContext';

const Partnership = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="partnership" className="partnership-section">
      <div className="partnership-container">
        <div className="partnership-content">
          <div className="partnership-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#ff8c42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="#ff8c42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="#ff8c42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="partnership-heading">
            {t('greatIdea')}
          </h2>
          <p className="partnership-text">
            {t('partnerText')} <span className="highlight">HonouredTech</span> {t('visionText')}
          </p>
          <h2>{t('lets')}</h2>
          <div className="partnership-values">
            <div className="value-item">
              <div className="value-icon">🚀</div>
              <div className="value-text">{t('riseTogether')}</div>
            </div>
            <div className="value-item">
              <div className="value-icon">💡</div>
              <div className="value-text">{t('innovateTogether')}</div>
            </div>
            <div className="value-item">
              <div className="value-icon">📈</div>
              <div className="value-text">{t('growTogether')}</div>
            </div>
          </div>
          <button className="cta-button" onClick={scrollToContact}>{t('startBuilding')}</button>
        </div>
      </div>
    </section>
  );
};

export default Partnership;
